var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Sorting',{attrs:{"defaultSelected":_vm.defaultParams.order_by},model:{value:(_vm.defaultParams.order_by),callback:function ($$v) {_vm.$set(_vm.defaultParams, "order_by", $$v)},expression:"defaultParams.order_by"}}),_vm._l((_vm.items),function(item){return _c('LuckyDrawCard',{key:item.id,attrs:{"item":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }